"use client";

export function BrandContextMenu({ children }: { children: React.ReactNode }) {
  // Brand context actions removed per request
  return <>{children}</>;
}
